import * as clientService from "../services/client.service";

export const getAssignedClientProfile = (clientId) => (dispatch) => {
  dispatch({
    type: "ASSIGNED_CLIENT_PROFILE_INIT",
  });
  return clientService
    .getAssignedClientProfile(clientId)
    .then((response) => {
      const { profileInfo, profilePic } = response?.data ?? response;
      dispatch({
        type: "ASSIGNED_CLIENT_PROFILE_SUCCESS",
        payload: { profileInfo, profilePic },
      });
      dispatch({
        type: "SUPPORT_PLAN_GROUP_USERS_SUCCESS",
        payload: profileInfo.carePlanGroupUsers,
      });
      return Promise.resolve(true);
    })
    .catch((err) => {
      dispatch({
        type: "GET_ASSIGNED_CLIENT_PROFILE_ERROR",
        payload: err.message,
      });
    });
};
